import Golf6 from "../images/cars-big/golf6.jpg";
import AudiA1 from "../images/cars-big/audia1.jpg";
import Toyota from "../images/cars-big/toyotacamry.jpg";
import Bmw320 from "../images/cars-big/bmw320.jpg";
import Benz from "../images/cars-big/benz.jpg";
import Passat from "../images/cars-big/passatcc.jpg";

export const CAR_DATA = [
  [
    {
      name: "Toyota Supra",
      price: "37",
      img: Golf6,
      make: "Toyota",
      model: "Supra A90",
      year: "2021",
      engine: "3.0L inline 6-cylinder",
      drivetrain: "RWD",
      transmission: "6-Speed/Man.",
      horsepower: "382",
    },
  ],
  [
    {
      name: "Audi R8",
      price: "45",
      img: AudiA1,
      make: "Audi",
      model: "R8 Spyder",
      year: "2023",
      engine: "5.2L V-10 FSI",
      drivetrain: "RWD",
      transmission: "7-Speed, dual clutch S-Tronic",
      horsepower: "585",
    },
  ],
  [
    {
      name: "Dodge Challenger",
      price: "30",
      img: Toyota,
      make: "Dodge",
      model: "Challenger SRT Hellcar",
      year: "2022",
      engine: "Supercharged 6.2L HEMI V8",
      drivetrain: "RWD",
      transmission: "6 Speed/Man.",
      horsepower: "807",
    },
  ],
  [
    {
      name: "Mercedes-Benz",
      price: "50",
      img: Bmw320,
      make: "Mercedes",
      model: "AMG GT BS",
      year: "2023",
      engine: "AMG 4.0L V8 Biturbo",
      drivetrain: "AWD",
      transmission: "7-Speed dual clutch",
      horsepower: "577",
    },
  ],
  [
    {
      name: "Porsche 911",
      price: "35",
      img: Benz,
      make: "Porsche",
      model: "911 GT3RS",
      year: "2023",
      engine: "4.0L flat 6-Cylinder",
      drivetrain: "RWD",
      transmission: "7-Speed/Auto.",
      horsepower: "518",
    },
  ],
  [
    {
      name: "McLaren F1",
      price: "25",
      img: Passat,
      make: "McLaren",
      model: "F1 LM GTR",
      year: "2021",
      engine: "6.1L BMW S70/2 V12",
      drivetrain: "RWD",
      transmission: "Transverse 6-Speed/Man",
      horsepower: "618",
    },
  ],
];